import clsx from "clsx";
import styles from "./Message.module.scss";

type IMessage = {
  message: string;
  type: "sent-by-me" | "sent-by-other" | "received";
  enableClickableLinks: boolean;
};

// URL regex pattern that matches common URL formats
const URL_REGEX = /(https?:\/\/[^\s]+)/g;

const linkifyText = (text: string) => {
  const parts = text.split(URL_REGEX);

  return parts.map((part, index) => {
    // Check if this part is a URL
    if (part.match(URL_REGEX)) {
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

export const Message = ({ message, type, enableClickableLinks }: IMessage) => {
  return (
    <div className={clsx([styles.message, styles[`type-${type}`]])}>
      <p>{enableClickableLinks ? linkifyText(message) : message}</p>
    </div>
  );
};
